var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 87,
    viewBox: "0 0 56 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.54102 2.91885L4.73843 1.04786C5.15612 0.8013 5.73224 0.83756 6.36597 1.20741L3.16847 3.07839C2.53474 2.70855 1.9587 2.67228 1.54102 2.91885Z",
    fill: "url(#paint0_linear_7011_100)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2375 84.3466L52.04 86.2176C52.4505 85.9783 52.7025 85.4634 52.7097 84.7382L55.9072 82.8672C55.9072 83.5924 55.6479 84.1073 55.2375 84.3466Z",
    fill: "url(#paint1_linear_7011_100)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7306 34.5546L55.928 32.6836L55.8993 82.8669L52.709 84.7379L52.7306 34.5546Z",
    fill: "url(#paint2_linear_7011_100)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16895 3.08585L6.36645 1.21484L53.6442 28.6996L50.4539 30.5706L3.16895 3.08585Z",
    fill: "url(#paint3_linear_7011_100)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4541 30.5741L53.6516 28.7031C54.9191 29.4356 55.9344 31.2196 55.9344 32.6844L52.737 34.5554C52.737 33.0905 51.7216 31.3138 50.4541 30.5741Z",
    fill: "url(#paint4_linear_7011_100)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4514 30.5688C51.7189 31.3012 52.7343 33.0852 52.7343 34.5501L52.7055 84.7333C52.7055 86.1982 51.6757 86.7856 50.4083 86.0532L3.13056 58.5612C1.8631 57.8287 0.847656 56.0447 0.847656 54.5799L0.87649 4.3966C0.87649 2.93171 1.90626 2.3443 3.17372 3.07675L50.4514 30.5688Z",
    fill: "url(#paint5_linear_7011_100)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5887 50.0559L19.1863 46.3594L18.1269 49.2847L14.7414 47.3301L20.522 32.0788L24.276 34.2462L30.0566 56.1724L26.6481 54.2045L25.5887 50.0559ZM24.7136 46.5722L22.3875 37.464L20.0614 43.8863L24.7136 46.5722ZM35.4416 40.7193L35.4416 59.2814L32.2174 57.4199L32.2174 38.8577L35.4416 40.7193Z",
    fill: "url(#paint6_linear_7011_100)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7011_100",
    x1: -4.50818,
    y1: -6.45784,
    x2: 27.5807,
    y2: 25.4149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7011_100",
    x1: 53.97,
    y1: 93.6581,
    x2: 53.97,
    y2: 71.7209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7011_100",
    x1: 54.3149,
    y1: 114.028,
    x2: 54.3149,
    y2: 41.9878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7011_100",
    x1: 0.850067,
    y1: -11.8604,
    x2: 32.9463,
    y2: 20.0126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7011_100",
    x1: 53.1907,
    y1: 57.457,
    x2: 53.1907,
    y2: 35.5199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7011_100",
    x1: -19.4893,
    y1: -2.03586,
    x2: 53.1876,
    y2: 70.1356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7011_100",
    x1: 25.8339,
    y1: 24.7344,
    x2: 8.51341,
    y2: 54.7344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9C6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFC9F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIllustration);
export default __webpack_public_path__ + "static/media/ai-illustration.68845f6e8edacbed0da131f701190c04.svg";
export { ForwardRef as ReactComponent };